import { APP_STYLE_PALETTE, MSI_GEOMETRY, usesAppStyleGrammar } from './msiStyleTokens';

export const WORKSPACE_DIMENSIONS = Object.freeze({
  sectionGap: 16,
  primaryTableHeight: 540,
  attributeTableHeight: 380,
  optimizerStackHeight: 840,
});

export const workspaceSectionSx = {
  mb: 3,
};

export const workspacePanelHeaderSx = {
  minHeight: 44,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 1.5,
  mb: 1.25,
  flexWrap: 'wrap',
};

export const workspacePanelHeadingSx = {
  minWidth: 0,
  display: 'grid',
  gap: 0.2,
};

export const workspacePanelDescriptionSx = {
  color: (theme) => (
    usesAppStyleGrammar(theme) ? APP_STYLE_PALETTE.ink500 : theme.palette.text.secondary
  ),
  fontSize: '0.72rem',
  lineHeight: 1.35,
};

// Constraints workspace (about two thirds) beside the persistent outcome panel;
// stacked below the large breakpoint.
export const optimizerWorkspaceGridSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: 'minmax(0, 1fr)',
    lg: 'minmax(0, 2fr) minmax(320px, 1fr)',
  },
  gap: '12px',
  alignItems: 'stretch',
  mb: `${WORKSPACE_DIMENSIONS.sectionGap}px`,
};

export const optimizerWorkspacePanelSx = {
  p: 1.5,
};

export const workspaceActionClusterSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 1,
  ml: { sm: 'auto' },
  flexWrap: 'wrap',
  minWidth: 0,
};

export const workspacePrimarySplitSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: 'minmax(0, 1fr)',
    xl: 'minmax(0, 1.55fr) minmax(350px, 1fr)',
  },
  gap: `${WORKSPACE_DIMENSIONS.sectionGap}px`,
  alignItems: 'stretch',
  mb: `${WORKSPACE_DIMENSIONS.sectionGap}px`,
};

export const workspaceEqualSplitSx = {
  display: 'grid',
  gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: 'repeat(2, minmax(0, 1fr))' },
  gap: `${WORKSPACE_DIMENSIONS.sectionGap}px`,
  alignItems: 'stretch',
};

export const workspacePanelElevationSx = {
  borderRadius: (theme) => (
    usesAppStyleGrammar(theme) ? `${MSI_GEOMETRY.radii.panel}px` : undefined
  ),
  boxShadow: (theme) => (
    usesAppStyleGrammar(theme) && theme.palette.mode !== 'dark'
      ? '0 8px 26px rgba(22, 55, 90, 0.045)'
      : undefined
  ),
};
